import axios from "axios";
import { ACCOUNT_ENUMS } from "../../utils";

export const authService = {
  signUp: (body) => axios.post("/user", body),

  signIn: (body) => axios.post("/auth/signin", body),

  logOut: () => axios.post(`/auth/logout`, {}, { auth: true }),

  getLink: (email) => axios.get(`/auth/forgotPassword/${email}`),

  resetPass: (info) =>
    axios.post(
      "/auth/resetPassword",
      { ...info },
      { headers: { "reset-token": info.token } }
    ),

  completeRegistration: (info) =>
    axios.post(
      "/auth",
      {
        newPassword: info.newPassword,
        confirmation: info.confirmation,
      },
      { headers: { "registration-token": info.token } }
    ),

  changePasswordService: (data) =>
    axios.post("/auth/changePassword", data, { auth: true }),

  myProfileService: (type) =>
    axios.get(
      type === ACCOUNT_ENUMS.CHARITY ? `/charity/profile` : `/user/myProfile`,
      {
        auth: true,
      }
    ),

  resendInvite: (id, body) =>
    axios.post(`/auth/${id}/resendInvite`, body, { auth: true }),

  editAccountService: (data) => axios.patch(`/user`, data, { auth: true }),

  deleteAccountService: (id) => axios.delete(`/user/${id}`, { auth: true }),

  inviteUserService: (params) =>
    axios.patch(`/users/invite`, params, { auth: true }),

  searchService: (params) =>
    axios.post(`/search`, null, { params: { ...params } }),
};
